import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import { FreeMode, Scrollbar } from 'swiper/modules';
import { useTranslation } from 'next-i18next';
import { observer } from 'mobx-react-lite';
import { ISlide } from '@features/productPreview/typescript';
import { WindowType } from '@typescript/index';
import styles from '@features/productPreview/sections/Gallery/GalleryStyles.styles';
import SlideControl from '@components/SlideControl/SlideControl';
import { uiState } from '@features/productPreview/mobX/state/context';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/scrollbar';
import 'swiper/css/free-mode';
type PropsType = {
  slides: ISlide[];
  windowType: WindowType;
  onSelectImage: (slide: ISlide) => void;
};
const GallerySlider = ({
  slides,
  windowType,
  onSelectImage
}: PropsType) => {
  const [shouldRenderArrows, SetShouldRenderArrows] = useState({
    left: false,
    right: true
  });
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass>();
  const [onClient, setClient] = useState(false);
  const {
    productName
  } = uiState;
  const {
    t
  } = useTranslation('common');
  useEffect(() => {
    // update some client side state to say it is now safe to render the client-side only component
    setClient(true);
  }, []);
  const updateRenderArrows = () => {
    if (!swiperInstance) return;
    SetShouldRenderArrows({
      left: !swiperInstance.isBeginning && !!swiperInstance.allowSlidePrev,
      right: !swiperInstance.isEnd && !!swiperInstance.allowSlideNext
    });
  };
  const onSlideChange = () => {
    updateRenderArrows();
  };
  useEffect(() => {
    updateRenderArrows();
  }, []);
  const isDesktop = windowType === WindowType.desktop;
  if (!onClient || slides.length === 0) {
    return null;
  }
  const onControlClick = (dir: 'next' | 'prev') => {
    if (!swiperInstance) return;
    if (dir === 'prev') swiperInstance.slidePrev();
    if (dir === 'next') swiperInstance.slideNext();
    updateRenderArrows();
  };
  return <>
      <div sx={styles.sliderContainer} data-cy="GallerySlider">
        <Swiper slidesPerView="auto" freeMode width={null} scrollbar={{
        draggable: true
      }} spaceBetween={isDesktop ? 24 : 1} modules={[FreeMode, Scrollbar]} onActiveIndexChange={onSlideChange} onSwiper={swiper => setSwiperInstance(swiper)}>
          {slides.map(slider => <SwiperSlide key={slider.id}>
              <div sx={styles.sliderImgStyles} onClick={() => isDesktop && onSelectImage(slider)} onKeyDown={e => e.key === 'Enter' && isDesktop && onSelectImage(slider)} role="button" tabIndex={0}>
                <ResponsiveImage alt={`${productName} ${t('arrangement.single')}`} image={slider.image[windowType]} objectPosition="center" />
              </div>
            </SwiperSlide>)}
        </Swiper>

        {shouldRenderArrows.right && <SlideControl direction="next" onClick={onControlClick} withScrollbar />}
        {shouldRenderArrows.left && <SlideControl direction="prev" onClick={onControlClick} withScrollbar />}
      </div>
    </>;
};
export default observer(GallerySlider);